import { createSlice } from '@reduxjs/toolkit';
import * as liveMapActionTypes from './liveMapActions.types';
import type { LiveMapState } from './types/LiveMap.types';

// Map-rendering slice only (background image, planned path, trail, position, zones). The routine
// timeline/availability fields are a separate piece of work extending this same state shape.
export const initialState: LiveMapState = {
  status: 'idle',
  robotId: null,
  mapInfo: null,
  mapImageUrl: null,
  plannedPath: [],
  trail: [],
  livePosition: null,
  subscriptionStatus: 'disconnected',
  cleaningZones: [],
  cleaningZoneFeatures: null,
  activeCleaningZoneIds: null,
  error: null,
};

const liveMapSlice = createSlice({
  name: 'live-map',
  initialState,
  reducers: {
    openLiveMapRequest: (state, action: liveMapActionTypes.OpenLiveMapRequestAction) => {
      state.status = 'loading';
      state.robotId = action.payload.robotId;
      state.error = null;
      return state;
    },
    openLiveMapSuccess: (state, action: liveMapActionTypes.OpenLiveMapSuccessAction) => {
      state.status = 'open';
      state.mapInfo = action.payload.mapInfo;
      state.mapImageUrl = action.payload.mapImageUrl;
      state.plannedPath = action.payload.plannedPath;
      state.trail = action.payload.trail;
      state.livePosition = action.payload.livePosition;
      state.cleaningZones = action.payload.cleaningZones;
      state.cleaningZoneFeatures = action.payload.cleaningZoneFeatures;
      state.activeCleaningZoneIds = action.payload.activeCleaningZoneIds;
      state.subscriptionStatus = 'connected';
      return state;
    },
    openLiveMapError: (state, action: liveMapActionTypes.OpenLiveMapErrorAction) => {
      state.status = 'error';
      state.error = action.payload.error;
      return state;
    },
    closeLiveMap: () => initialState,
    deviceMapPositionReceived: (state, action: liveMapActionTypes.DeviceMapPositionReceivedAction) => {
      // Extends the trail fetched once at open — deviceMapLocation isn't re-polled while open.
      state.trail.push({ x: action.payload.x, y: action.payload.y, updatedAt: action.payload.lastUpdated });
      state.livePosition = {
        x: action.payload.x,
        y: action.payload.y,
        heading: action.payload.heading,
        lastUpdated: action.payload.lastUpdated,
      };
      state.subscriptionStatus = 'connected';
      return state;
    },
    subscriptionStatusChanged: (state, action: liveMapActionTypes.SubscriptionStatusChangedAction) => {
      state.subscriptionStatus = action.payload.status;
      return state;
    },
  },
});

export const LiveMapActions = {
  ...liveMapSlice.actions,
};
export const liveMapReducer = liveMapSlice.reducer;
